'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonWithRef = ButtonWithRef;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function ButtonWithRef(_ref) {
  var label = _ref.label,
      handleClick = _ref.handleClick,
      reference = _ref.reference,
      disabled = _ref.disabled;
  return _react2['default'].createElement('button', {
    className: 'btn btn-default btn-sm',
    onClick: handleClick,
    ref: reference,
    disabled: disabled
  }, label);
}

ButtonWithRef.propTypes = {
  label: _propTypes2['default'].string,
  handleClick: _propTypes2['default'].func,
  reference: _propTypes2['default'].func,
  disabled: _propTypes2['default'].bool
};